import { Helmet } from 'react-helmet-async';
import CategoryPageTemplate from '../components/CategoryPageTemplate';
import { DHOOP_STICK } from '../data/products';

const heroImg = "/images/abouthero.webp";

const DHOOP_STICK_TIERS = [
  { id: "Premium", label: "Premium",      icon: "⭐", desc: "Elevated experience", badge: "LATEST" },
  { id: "Luxury",  label: "Luxury",       icon: "💎", desc: "Ultra premium",       badge: "NEW" },
  { id: "All",     label: "All Products", icon: "✦", desc: "",                    badge: null },
];

export default function DhoopStickPage() {
  return (
    <>
      <Helmet>
        <title>Buy Dhoop Sticks Online | Premium & Luxury Dhoop Sticks — Prakhyat</title>
        <meta
          name="description"
          content="Shop Prakhyat Dhoop Sticks online — Premium & Luxury Masala Dhoop Sticks in Sandalwood, Oud, Guggal, Rose & more fragrances. Bamboo-less, export quality, 100% natural. Perfect for Temples, Meditation & Home use."
        />
        <meta
          name="keywords"
          content="buy dhoop stick online, premium dhoop stick, luxury dhoop stick, bamboo less dhoop stick, sandalwood dhoop stick, oud dhoop stick, guggal dhoop stick, natural dhoop stick india, temple dhoop stick, prakhyat dhoop stick, export quality dhoop stick, masala dhoop stick, dhoop stick meditation, dhoop stick pooja"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://prakhyatagarbatti.com/products/dhoop-stick" />
      </Helmet>

      <CategoryPageTemplate
        title="Dhoop Stick Collection"
        subtitle="Long-lasting sacred fragrance sticks — crafted for temples, homes and meditation"
        products={DHOOP_STICK}
        heroBg={heroImg}
        tiers={DHOOP_STICK_TIERS}
        seoDesc="Buy premium Dhoop Sticks from Prakhyat — 100% natural. Made in Virar, Palghar."
        extraTags={{ bottomLeft: "Bamboo Less", bottomRight: "Export Quality" }}
      />
    </>
  );
}